export default __webpack_public_path__ + "static/media/about-layer-0.f0a49105.png";